import {cast, Instance, SnapshotOut, types} from "mobx-state-tree"
import {AuthCredentials} from "../auth-credentials/auth-credentials";
import {AuthFirestore} from "../../services/firestore/auth-firestore";
import {staffFromJson, StaffModel, StaffSnapshot} from "../staff/staff";
import {load as loadFromStorage, save as saveToStorage} from "../../utils/storage/storage"
import {hasValue} from "../../utils/empty-check";

/**
 * Example store containing Rick and Morty characters
 */
export const AuthStoreModel = types
    .model("AuthStore")
    .props({
        staff: types.maybe(StaffModel)
    })
    .actions((self) => ({
        saveStaff: async (data: StaffSnapshot) => {
            self.staff = cast(data)
        },
        storeStaff: async (data: StaffSnapshot) => {
            await saveToStorage("staff", data)
        },
        loadStaff: async () => {
            const staff = await loadFromStorage("staff")
            if (hasValue(staff)) {
                self.staff = cast({...staffFromJson({...staff})})
            }
            return self.staff
        },
    }))
    .actions((self) => ({
        authenticateStaff: async (formData: AuthCredentials) => {
            const authFirestore = new AuthFirestore()
            const result = await authFirestore.authenticateStaff(formData)

            if (result.kind === "ok" && result.data !== undefined) {
                self.saveStaff(result.data)
                self.storeStaff(result.data)
                return result.data
            } else {
                console.log(result.kind)
                return null
            }
        },
        logout: async () => {
            const authFirestore = new AuthFirestore()
            const result = await authFirestore.logout()

            if (result.kind === "ok") {
                return true
            } else {
                console.log(result.kind)
                return false
            }
        },
    }))

type AuthStoreType = Instance<typeof AuthStoreModel>

export interface AuthStore extends AuthStoreType {
}

type AuthStoreSnapshotType = SnapshotOut<typeof AuthStoreModel>

export interface AuthStoreSnapshot extends AuthStoreSnapshotType {
}

export const createAuthStoreDefaultModel = () => types.optional(AuthStoreModel, {})
